<template>
  <JyPagebody :activatedLoad="reloadData">
    <TemplateList title="日志查看">
      <template slot="searchBar">
        <div class="mb-1 ml-md-2">
          <el-checkbox v-model="searchData.islogin" label="不显示登录日志"></el-checkbox>
        </div>
        <div class="mb-1 ml-md-2">
          <el-select v-model="searchData.type" size="small" placeholder="查询：类型" clearable filterable style="width:8rem">
            <el-option v-for="(v, k) in logstype" :label="v" :value="k" :key="k"></el-option>
          </el-select>
        </div>
        <div class="mb-1 ml-md-2">
          <el-input v-model="searchData.content" size="small" placeholder="查询：日志内容" style="width:9rem" clearable></el-input>
        </div>
        <JyButton type="primary" icon="search" class="mb-1 ml-md-1" @click="doSearch">查询</JyButton>
      </template>
      <div slot="card" v-loading="loadedData" element-loading-text="努力加载中..." class="row col-gutters-10">
        <div v-if="!list || !list.length" class="col">
          <div class="card mb-3 box-shadow">
            <div class="card-body">
              <i class="fa fa-exclamation-circle text-danger">&nbsp;&nbsp;</i>未查询到数据...
            </div>
          </div>
        </div>
        <div v-for="(item, index) in list" :key="item.id" class="col-xs-4 col-sm-3">
          <div class="card mb-3 box-shadow" @mouseenter="enterCard(1, $event)" @mouseleave="enterCard(0, $event)">
            <div class="card-body">
              <div class="d-flex justify-content-between">
                <div># {{ index + 1 }}</div>
                <div class="ellipsis">【{{ logstype[item.type] || item.type }}】</div>
              </div>
              <a v-if="item.type != 'login'" class="d-block pt-2 pb-2" href="javascript:;" title="查看" @click="doView(item)">{{ item.content }}</a>
              <div v-if="item.type == 'login'" class="d-block pt-2 pb-2">{{ item.content }}</div>
              <div class="d-flex justify-content-between">
                <div><i class="fa fa-user-o"></i> {{ item.name }}</div>
                <div class="text-muted"><i class="fa fa-clock-o"></i> {{ item.createtime }}</div>
              </div>
              <!-- <div class="mt-1 pt-1 border-top">
                <div class="text-right">
                  <JyButton v-if="hasPermiss('other.log.del')" type="danger" size="sm" @click="doDel(item, index, list)" icon="times">删除</JyButton>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
      <el-table
        slot="grid"
        ref="grid"
        highlight-current-row
        border
        :data="list"
        row-key="id"
        @selection-change="handleSelection"
        v-loading="loadedData"
        height="100%"
        style="width: 100%">
        <!-- <el-table-column
          type="selection"
          fixed
          width="55" /> -->
        <jy-table-column
          fixed
          type="index">
          <!-- <template slot="title" slot-scope="scope">
            <el-popover
              placement="top"
              append-to-body
              trigger="click">
              <div class="d-flex justify-content-center">
                <JyButton v-if="hasPermiss('other.log.del')" type="danger" size="sm" @click="doDelSelect()">删除</JyButton>
              </div>
              <a href="javascript:;" slot="reference" class="d-block pr-1 text-nowrap text-danger">批量<i class="fa fa-caret-down fa-fw"></i></a>
            </el-popover> -->
          <!-- </template> -->
        </jy-table-column>
        <jy-table-column
          prop="name"
          label="用户"
          width="80">
          <template slot-scope="scope">
            <div>{{ scope.row.name }}</div>
          </template>
        </jy-table-column>
        <jy-table-column
          prop="content"
          label="类型"
          show-overflow-tooltip
          width="120">
          <template slot-scope="scope">
            <div>{{ logstype[scope.row.type] || scope.row.type }}</div>
          </template>
        </jy-table-column>
        <jy-table-column
          prop="content"
          label="日志内容">
          <template slot-scope="{row}">
            <div><a v-if="row.type != 'login'" href="javascript:;" @click="doView(row)">{{ row.content }}</a>
              <span v-if="row.type == 'login'">{{ row.content }}</span>
            </div>
          </template>
        </jy-table-column>
        <jy-table-column
          prop="createtime"
          label="日志时间">
          <template slot-scope="scope">
            <span>{{ scope.row.createtime }}</span>
          </template>
        </jy-table-column>
        <!-- <el-table-column
          fixed="right"
          label="操作"
          width="60">
          <template slot-scope="scope">
            <el-popover
              ref="popover-edit"
              placement="bottom"
              append-to-body
              trigger="click">
              <div class="d-flex justify-content-center">
                <JyButton v-if="hasPermiss('other.log.del')" type="danger" size="sm" class="ml-2 mr-2" @click="doDel(scope.row)">删除</JyButton>
              </div>
              <a href="javascript:;" slot="reference" class="d-block text-nowrap">操作<i class="fa fa-caret-down fa-fw"></i></a>
            </el-popover>
          </template>
        </el-table-column> -->
      </el-table>
    </TemplateList>
    <el-pagination
      slot="footer"
      :small="isSm"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="pageSizeList"
      :page-size="pageSize"
      :layout="pageLayout"
      :total="totalRow">
    </el-pagination>
  </JyPagebody>
</template>

<script>
import { mapGetters } from 'vuex';
import * as types from 'jystore/mutation-types';
import tools from 'jyutils/tools';
import list from '../mixin/list';
import TemplateList from '../template-list.vue';
export default {
  components: {
    TemplateList
  },
  mixins: [tools, list],
  data() {
    return {
      searchData: {type:'', content:'', islogin:false}
    }
  },
  computed: {
    ...mapGetters({
      logstype: [types.STATUS.logstype]
    }),
    listUrl() {
      return 'sys/logs';
    },
    queryData() {
      return Object.assign({}, {pageCurrent: this.currentPage, pageSize: this.pageSize}, this.searchData);
    }
  },
  watch: {
  },
  methods: {
    reloadData() {
      if (!this.list || !this.list.length)
        this.loadList();

      if (!this.logstype || !Object.keys(this.logstype).length) {
        this.$store.dispatch(types.STATUS.logstype);
      }
    },
    doDel(data) {
      this.msgbox('此操作将永久删除该记录, 是否继续?', () => {
        this.doPost({
          url: 'sys/logs/del/'+ data.id,
          okcb: () => {
            this.$msg.success('删除成功!');
          }
        });
      });
    },
    // 查看记录
    doView(data) {
      this.editData = {};
      if (data.type == 'stuinfo') {
        this.$router.push('/stu-view/'+ data.businessid);
      } else if (data.type == 'sturoll') {
        this.$router.push('/stu-view/'+ data.stuid + '?rollid='+ data.businessid);
      } else if (data.type == 'rollchange') {
        this.$router.push('/roll-change-edit/'+ data.businessid);
      } else if (data.type == 'point') {
        this.editData.pointid = data.businessid;
        this.$refs.pointView.show(true);
      } else if (data.type == 'area') {
        this.$router.push('/map-area');
      }
    },
    doDelSelect() {
      if (!this.selectedId.length) {
        this.$msg.warning('未选中任何记录！');
        return;
      }
      this.msgbox('此操作将永久删除选中记录, 是否继续?', () => {
        this.doPost({
          url: 'sys/logs/del',
          data: {ids: this.selectedId.join(',')},
          okcb: () => {
            this.$msg.success('删除成功!');
            this.loadList();
          }
        });
      });
    },
    handleSelection(selection) {
      this.selectedId = selection.map(d => {
        return d.id;
      });
    }
  }
}
</script>
